import React from 'react';
import { UserContext } from '../context';
import useMergedGuestCart from '../hooks/use-merged-guest-cart';
import { useUser } from '../hooks/use-user';
import { jsx as _jsx } from "react/jsx-runtime";
const UserStateProvider = _ref => {
  let {
    children
  } = _ref;
  const userData = useUser();
  useMergedGuestCart(userData.user);
  return /*#__PURE__*/_jsx(UserContext.Provider, {
    value: userData,
    children: children
  });
};
export default UserStateProvider;